<div class="field">
  <app-form-edit-field-label
    [fieldType]="fieldTypes.TEXT"
    #label
    [(data)]="data.label"></app-form-edit-field-label>
</div>
